// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { memo } from 'react'
import { useLocation } from 'react-router-dom'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { Dropdown, PrimaryButton, SecondaryButton } from 'ui_kit_qmd'
import './PastVisitNotesHeader.scss'
import {
  CLOSE_TEXT,
  VISIT_TEXT,
  COMPLETE,
  UNRESOLVED,
  STATUS,
  PATIENT_UPCOMING_VISIT_PAGE_PATH,
  VISIT_CALL_ROOM_UNRESOLVED_REASON_POP_UP_PRIMARY_BTN_TEXT,
} from '../../../../../utils/constants'

const endVisitOptionsList = [COMPLETE, UNRESOLVED]

const buttonContainerStyle = {
  height: 40,
  width: 200,
}

const endVisitDropDownListItemStyle = {
  padding: '8px 32px 8px 16px',
}

const endVisitTypeDropdownContainerStyle = {
  width: 198,
  height: 38,
  boxSizing: 'content-box',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'row',
  border: '1px solid #00A2B2',
  borderStyle: 'solid',
  background: '#00A2B2',
  '-webkit-text-fill-color': 'rgba(255, 255, 255, 1)',
  color: 'rgba(255, 255, 255, 1)',
}

const endVisitDropdownIconStyle = {
  cursor: 'pointer',
  top: 13,
  right: 58,
  filter: 'brightness(0) invert(1)',
  width: 11,
  height: 7,
}

const endVisitDropdownInputStyle = {
  padding: 0,
  margin: '0px 0px 0px -15px',
  height: 28,
  width: 90,
  '-webkit-text-fill-color': 'rgba(255, 255, 255, 1)',
  color: 'rgba(255, 255, 255, 1)',
  background: '#00A2B2',
  fontsize: 20,
  lineHeight: 27,
  textAlign: 'center',
  letterSpacing: 1.5,
  fontWeight: '700',
}

const endVisitDropdownListContainerStyle = {
  width: 199,
  marginTop: 6,
  height: 88,
}

const closeBtnLabelStyle = {
  fontWeight: '700',
  fontSize: 20,
}

const closeBtnContainerStyle = {
  height: 38,
  width: 200,
  marginRight: 32,
}

export const PastVisitNotesHeader = memo(
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  ({ dateTimeValue, isNotCompleted, setVisitStatus, onClickClose, onSaveVisitNote, visitNotesList = [] }) => {
    const location = useLocation()
    const isUpcomingVisit = location.pathname === PATIENT_UPCOMING_VISIT_PAGE_PATH
    const hasNotesUpcomingVisit = isUpcomingVisit && visitNotesList.length

    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    const onChangeStatus = (value) => {
      setVisitStatus(value)
    }

    return (
      <div className='patient-past-visit-notes-header'>
        <div className='patient-past-visit-notes-header-date-time'>
          {VISIT_TEXT} {dateTimeValue}
        </div>
        {isNotCompleted ?
          <div className='patient-past-visit-notes-header-buttons-wrapper'>
            {hasNotesUpcomingVisit ? null : (
              <SecondaryButton
                id='patient-past-visit-notes-header-close-button'
                btnText={CLOSE_TEXT}
                onPress={onClickClose}
                labelStyle={closeBtnLabelStyle}
                containerStyle={closeBtnContainerStyle}
              />
            )}
            {isUpcomingVisit ?
              <PrimaryButton
                btnText={hasNotesUpcomingVisit ? CLOSE_TEXT : VISIT_CALL_ROOM_UNRESOLVED_REASON_POP_UP_PRIMARY_BTN_TEXT}
                onPress={hasNotesUpcomingVisit ? onClickClose : onSaveVisitNote}
                containerStyle={buttonContainerStyle}
              />
            : null}
            {!isUpcomingVisit && (
              <div className='patient-past-visit-notes-header-dropdown-wrapper'>
                <Dropdown
                  isStateDropdown
                  options={endVisitOptionsList}
                  isWithoutLabel
                  dropDownListItemStyle={endVisitDropDownListItemStyle}
                  containerStyle={endVisitTypeDropdownContainerStyle}
                  customIconStyles={endVisitDropdownIconStyle}
                  inputStyle={endVisitDropdownInputStyle}
                  dropdownContainerStyle={endVisitDropdownListContainerStyle}
                  value=''
                  setValue={onChangeStatus}
                  dropId='ViewDropDown'
                  label=''
                />
                <div className='patient-past-visit-notes-header-dropdown-title' id='dropdownTitleVideoCallRoomEndVisit'>
                  {STATUS}
                </div>
              </div>
            )}
          </div>
        : <PrimaryButton btnText={CLOSE_TEXT} onPress={onClickClose} containerStyle={buttonContainerStyle} />}
      </div>
    )
  },
)
